module.exports = __webpack_public_path__ + "img/login-logo.b9020498.png";